import { notification, Icon } from "@arkas/coreui";
import { AxiosError } from "axios";
import React from "react";

export enum NotificationType {
  success = "success",
  info = "info",
  warning = "warning",
  error = "error",
}

export const notifyUser = (
  type: NotificationType,
  title: String,
  description: string
) => {
  notification.open({
    type,
    message: title,
    description,
  });
};

export const notifyError = (error: string | AxiosError) => {
  if (typeof error === "string") {
    notification.open({
      type: NotificationType.error,
      message: "Hata",
      description: error,
    });
  } else {
    let errorDesc = "Bilinmeyen bir hata oluştu ";

    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      errorDesc = "Sunucu bağlantısı zamanaşımına uğradı";
    } else {
      errorDesc = error.response
        ? error.response.data.data.messages[0]
        : errorDesc;
    }

    notification.open({
      type: NotificationType.error,
      message: "Error",
      description: errorDesc,
    });
  }
};

export const notifyNoAuth = () => {
  notification.open({
    message: "Yetkiniz yok",
    description: "Bu işlemi gerçekleştirme yetkiniz yok.",
    icon: <Icon type="lock" theme="twoTone" />,
  });
};
